export class Modal {
  constructor(modalButton) {
    this.modalButton = modalButton;
    this.html = document.querySelector("html");
    this.openedModal = false;
    this.modalName = this.modalButton.getAttribute('data-module-modal');
    this.modal = document.querySelector(`[data-modal=${this.modalName}]`);

    this.modalButton.addEventListener("click", () => {
      this.openModal();
    });

    this.modal.querySelectorAll("[data-close]").forEach((item) => {
      item.addEventListener("click", () => {
        this.closeModal();
      });
    });
  }

  openModal() {
    this.openedModal = true;
    this.modal.classList.add("modal--opened");
    document.documentElement.setAttribute("data-modal-opened", "");
    this.modal.setAttribute('tabindex', '-1');
    this.modal.focus();
  }

  closeModal() {
    this.openedModal = false;
    this.modal.classList.remove("modal--opened");
    document.documentElement.removeAttribute("data-modal-opened");
    this.modalButton.focus();
  }
}
